import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnInit,
  Inject,
  inject,
  DestroyRef,
  input,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AccountResponse, AccountsApiService } from '@libs/customers/accounts';
import { SidebarService, DrawerService } from '@hub/page';

import { INavigationConfig } from '../types/navigation-config';

@Component({
  templateUrl: 'desktop.component.html',
  selector: 'hub-layout-desktop',
  styleUrls: ['./desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutDesktopComponent implements OnInit {
  private readonly sidebarService = inject(SidebarService);
  private readonly drawerService = inject(DrawerService);
  private readonly destroyRef = inject(DestroyRef);

  @Input() configuration: INavigationConfig[] = [];
  @Input() showAdminLogo: boolean = false;
  @Input() isEmployerApp: boolean = false;

  isTabletLarge = input<boolean>();

  account: AccountResponse;
  menuItems: INavigationConfig[] = [];

  last: string;

  isCollapsed = this.sidebarService.isCollapsed;
  isDrawerOpened = this.drawerService.drawerOpened;

  constructor(
    private router: Router,
    private accountsApiService: AccountsApiService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit(): void {
    this.menuItems = this.configuration.filter(
      (x: INavigationConfig) => x.enabled,
    );

    this.getAccount();

    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((v) => {
        if (v instanceof NavigationEnd) {
          // don't bounce just by changing the query string only for true
          // path changes in the URL
          if (this.last !== location.pathname) {
            // TODO: I saw this error locally. Seems like it can't find #desktop-content sometimes
            const desktopContentEl =
              this.document.querySelector('#desktop-content');

            // Prevents error if scrollTo isn't supported on your browser (IE, old Chrome, old Edge)
            if (typeof desktopContentEl.scrollTo === 'function') {
              desktopContentEl.scrollTo(0, 0);
            }
          }

          this.last = location.pathname;
        }
      });
  }

  getAccount(): void {
    this.accountsApiService.currentAccount$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((account: AccountResponse) => {
        this.account = account;
      });
  }

  navigateToExternal(item: INavigationConfig): void {
    // append the business id if it exists and has not already been appended to url
    if (
      item.label === 'Shifts' &&
      this.account?.id &&
      !item.route.includes('businessId')
    ) {
      item.route += '&businessId=' + this.account.id;
    }
  }
}
